import axios, { AxiosInstance } from 'axios';
import { API_URI } from 'configs/env.conf';

const httpClient: AxiosInstance = axios.create({
  baseURL: API_URI,
  timeout: 120000, // Waiting 2m for request timeout
  headers: {
    'Cache-Control': 'no-cache',
    'X-Client-Platform': 'web',
  },
});

httpClient.interceptors.request.use(function handleRequest(reqConfig) {
  const configOverride = reqConfig;

  const token = localStorage.getItem('token');

  if (token) {
    configOverride.headers.Authorization = `Bearer ${token}`;
  }

  return configOverride;
});

export default httpClient;
